import { Link } from 'react-router-dom'
import {useLogout} from '../hooks/useLogout'
import { useAuthcontext } from '../hooks/useAuthcontext'

//styles && images
import './Navbar.css'
import Temple from '../assets/work.svg'

export const Navbar = () => {
  const {user} =  useAuthcontext()
  console.log(user)
  const { logout, ispending } = useLogout()
  return (
    <div className='navbar'>
        <ul>
            <li className='logo'>
                <img src={Temple} alt="dojo logo"/>
                <span>Project Manager</span>
            </li>
          {!user && (
            <>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/signup">Signup</Link></li>
            </>
          )}
           {user && (
           <li>
             {!ispending && <button className='btn' onClick={logout} >Logout</button>}
             {ispending && <button className='btn' disabled>logging out</button>}
           </li>
           )}
        </ul>
    </div>
  )
}
